import React from "react";
import "../../css/capabilities/detectionAnimation.css";

const DetectionAnimation = () => {
  return (
    <div className="detection-animation-overlay">
      <svg className="detection-svg" xmlns="http://www.w3.org/2000/svg">
        {/* Scanning lines that animate */}
        <line className="scan-line scan-line-1" x1="10%" y1="20%" x2="40%" y2="50%" />
        <line className="scan-line scan-line-2" x1="60%" y1="30%" x2="90%" y2="60%" />
        <line className="scan-line scan-line-3" x1="30%" y1="60%" x2="60%" y2="80%" />
        <line className="scan-line scan-line-4" x1="70%" y1="70%" x2="85%" y2="85%" />
        
        {/* Target circles */}
        <circle className="target-circle target-1" cx="40%" cy="50%" r="8" />
        <circle className="target-circle target-2" cx="90%" cy="60%" r="8" />
        <circle className="target-circle target-3" cx="60%" cy="80%" r="8" />
      </svg>
    </div>
  );
};

export default DetectionAnimation;

